<template>
  <v-alert closable type="error" variant="tonal" class="mb-2">
    {{ countsText }}
  </v-alert>
</template>

<script setup>
import { computed } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';

const props = defineProps({
  notModelledProductsCount: Number,
  totalParentProductsCount: Number,
  establishedProductsCount: Number,
});
const { tkey } = useInternationalization('validationErrors');

const countsText = computed(() => {
  // Compute your display text using tkey and counts.
  return tkey('modelProducts', [
    props.notModelledProductsCount,
    props.totalParentProductsCount,
    props.establishedProductsCount,
  ]);
});
</script>
